const actions = {
    INITIAL_GET_USER_DONE               : 'INITIAL_GET_USER_DONE',
    SIGNIN_REQUEST                      : 'SIGNIN_REQUEST',
    SIGNIN_SUCCESS                      : 'SIGNIN_SUCCESS',
    SIGNIN_FAILED                       : 'SIGNIN_FAILED',
    GET_USER_REQUEST                    : 'GET_USER_REQUEST',
    GET_USER_SUCCESS                    : 'GET_USER_SUCCESS',
    GET_USER_FAILED                     : 'GET_USER_FAILED',
    LOGOUT                              : 'LOGOUT',
    SHOW_OVERLAY                        : 'SHOW_OVERLAY',
    HIDE_OVERLAY                        : 'HIDE_OVERLAY',
    GET_ENTERPRISES_REQUEST             : 'GET_ENTERPRISES_REQUEST',
    GET_ENTERPRISES_SUCCESS             : 'GET_ENTERPRISES_SUCCESS',
    GET_ENTERPRISES_FAILED              : 'GET_ENTERPRISES_FAILED',
    GET_EMAIL_ENTERPRISE_MAP_REQUEST    : 'GET_EMAIL_ENTERPRISE_MAP_REQUEST',
    GET_EMAIL_ENTERPRISE_MAP_SUCCESS    : 'GET_EMAIL_ENTERPRISE_MAP_SUCCESS',
    GET_EMAIL_ENTERPRISE_MAP_FAILED     : 'GET_EMAIL_ENTERPRISE_MAP_FAILED',
    SAVE_EMAIL_ENTERPRISE_MAP_REQUEST   : 'SAVE_EMAIL_ENTERPRISE_MAP_REQUEST',
    SAVE_EMAIL_ENTERPRISE_MAP_SUCCESS   : 'SAVE_EMAIL_ENTERPRISE_MAP_SUCCESS',
    SAVE_EMAIL_ENTERPRISE_MAP_FAILED    : 'SAVE_EMAIL_ENTERPRISE_MAP_FAILED'
}
export default actions;


// WEBPACK FOOTER //
// ./src/actions.js